import { IAppliedRewards } from '@fhs-legacy/frontend/src/state/loyalty/hooks/types';
import { ICartEntry } from '@rbi-ctg/menu';

import {
  getItemLoyaltyRewardDiscount,
  getItemOfferDiscount,
} from '../../../../../state/cart-store/loyalty-helpers';
import { priceForCartEntry } from '../../../../../utils';

interface PriceCalculationResult {
  finalItemPrice: number;
  originalPrice: number;
  isFree: boolean;
  shouldShowStrikeThrough: boolean;
}

export function calculateItemPrice(
  item: ICartEntry,
  isRewardApplied: boolean,
  selectedOffer: any,
  offerEligibleItem: any,
  appliedLoyaltyRewards: IAppliedRewards
): PriceCalculationResult {
  const originalPrice = priceForCartEntry(item);
  const isOfferEligibleItem = !!offerEligibleItem;

  let finalItemPrice = originalPrice;

  // Apply reward discount
  if (isRewardApplied) {
    const rewardDiscount = getItemLoyaltyRewardDiscount({
      cartEntry: item,
      appliedLoyaltyRewards,
    });
    finalItemPrice = finalItemPrice - rewardDiscount;
  }
  // Apply item level offer discount
  else if (isOfferEligibleItem) {
    const offerDiscount = getItemOfferDiscount({
      cartEntry: item,
      offer: selectedOffer,
      eligibleItem: offerEligibleItem,
    });
    finalItemPrice = finalItemPrice - offerDiscount;
  }

  const isFree = finalItemPrice === 0;
  const shouldShowStrikeThrough = isFree || isOfferEligibleItem;

  return {
    finalItemPrice,
    originalPrice,
    isFree,
    shouldShowStrikeThrough,
  };
}
